import { CalendarCardSize } from '../enums';
export {
  // 日历卡片无数据时的宽度
  CALENDAR_EMPTY_CARD_WIDTH,
} from '../components/NoDataCard';

// 日历卡片最大展示行数，超过该行数的日历卡片在折叠状态下 就会折叠，展开状态下则展示
export const MAX_ROW_NUM = 4;

export const STEPPER_DATE_FORMAT_MAP = {
  month: 'YYYY.MM',
  quarter: 'YYYY.Q',
  year: 'YYYY',
};

// 每一列的每一行仅展示一张日历卡片的最小列数（即列数大于等于该数值时，每一列的每一行仅展示一张日历卡片）
export const SINGLE_CALENDAR_CARD_COLS_NUM = 4;

// 列间距映射
export const CALENDAR_COL_SPACING_MAPPING: {
  [key in CalendarCardSize]: number;
} = {
  [CalendarCardSize.XS]: 40,
  [CalendarCardSize.S]: 40,
  [CalendarCardSize.M]: 40,
  [CalendarCardSize.L]: 40,
  [CalendarCardSize.XL]: 40,
};

// 日历卡片间距映射
export const CALENDAR_CARD_SPACING_MAPPING: {
  [key in CalendarCardSize]: number;
} = {
  [CalendarCardSize.XS]: 40,
  [CalendarCardSize.S]: 40,
  [CalendarCardSize.M]: 40,
  [CalendarCardSize.L]: 40,
  [CalendarCardSize.XL]: 40,
};

// 日历卡片宽度映射
export const CALENDAR_CARD_WIDTH_MAPPING: {
  [key in CalendarCardSize]: number;
} = {
  [CalendarCardSize.XS]: 160,
  [CalendarCardSize.S]: 383,
  [CalendarCardSize.M]: 383,
  [CalendarCardSize.L]: 383,
  [CalendarCardSize.XL]: 383,
};

// 默认日历卡片尺寸
export const DEFAULT_CALENDAR_CARD_SIZE = CalendarCardSize.M;
// 最小日历卡片尺寸
export const MIN_CALENDAR_CARD_SIZE = CalendarCardSize.XS;
// 最大日历卡片尺寸
export const MAX_CALENDAR_CARD_SIZE = CalendarCardSize.XL;
// 日历卡片尺寸集合
export const CALENDAR_CARD_SIZES = [
  CalendarCardSize.XS,
  CalendarCardSize.S,
  CalendarCardSize.M,
  CalendarCardSize.L,
  CalendarCardSize.XL,
];
// 默认列间距
export const DEFAULT_CALENDAR_COL_SPACING =
  CALENDAR_COL_SPACING_MAPPING[DEFAULT_CALENDAR_CARD_SIZE];
// 默认日历卡片间距
export const DEFAULT_CALENDAR_CARD_SPACING =
  CALENDAR_CARD_SPACING_MAPPING[DEFAULT_CALENDAR_CARD_SIZE];
// 默认日历卡片宽度
export const DEFAULT_CALENDAR_CARD_WIDTH = CALENDAR_CARD_WIDTH_MAPPING[DEFAULT_CALENDAR_CARD_SIZE];
